const normalizeId = (value) => {
    if (value === null || value === undefined) return ''
    return String(value).trim()
}

const collectIds = (bucket, value) => {
    if (value === null || value === undefined) return

    if (Array.isArray(value)) {
        value.forEach((item) => collectIds(bucket, item))
        return
    }

    if (typeof value === 'string') {
        const trimmed = value.trim()
        if (!trimmed) return

        if ((trimmed.startsWith('[') && trimmed.endsWith(']')) || (trimmed.startsWith('{') && trimmed.endsWith('}'))) {
            try {
                collectIds(bucket, JSON.parse(trimmed))
                return
            } catch (error) {
                // Fall through and treat it as a plain string id.
            }
        }

        bucket.add(trimmed)
        return
    }

    if (typeof value === 'object') {
        collectIds(bucket, value.id)
        collectIds(bucket, value.department_id)
        collectIds(bucket, value.suborganisation_id)
        collectIds(bucket, value.suborganization_id)
        collectIds(bucket, value.department)
        collectIds(bucket, value.departments)
        return
    }

    bucket.add(normalizeId(value))
}

export const getAnnouncementUserDepartmentIds = (userData) => {
    const ids = new Set()
    const staff = userData?.staff

        ;[
            staff?.department_id,
            staff?.suborganisation_id,
            staff?.suborganization_id,
            staff?.department,
            staff?.departments,
            userData?.department_id,
            userData?.department,
            userData?.departments,
        ].forEach((value) => collectIds(ids, value))

    return Array.from(ids)
}

export const getAnnouncementTargetIds = (announcement) => {
    const ids = new Set()

        ;[
            announcement?.target_ids,
            announcement?.targetIds,
            announcement?.department_ids,
            announcement?.target_department_ids,
            announcement?.target_departments,
        ].forEach((value) => collectIds(ids, value))

    return Array.from(ids)
}

export const canUserSeeAnnouncement = (announcement, userDepartmentIds = []) => {
    const targetType = String(announcement?.target_type || 'all').toLowerCase()

    if (targetType !== 'department') return true

    const targetIds = getAnnouncementTargetIds(announcement)
    if (targetIds.length === 0) return true

    const userIds = new Set(userDepartmentIds.map(normalizeId).filter(Boolean))
    if (userIds.size === 0) return false

    return targetIds.some((id) => userIds.has(normalizeId(id)))
}

export const getAnnouncementUserScopeKey = (userData) => {
    const userId = userData?.staff?.id || userData?.id || 'guest'
    const deptIds = getAnnouncementUserDepartmentIds(userData).sort()

    return [userId, ...deptIds].join(':')
}